"use client";

import React from "react";
import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import { caseStudies } from "src/utils/mock/caseStudies";
import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import TechsSection from "src/components/Common/TechsSection";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";
import CommonContactSection from "src/components/Common/CommonContactSection";

import {
  BrandPositioningHeroData,
  brandPositioningStatsData,
  brandPositioningSolutionsAndProcessData,
  brandPositioningPortfolioData,
  brandPositioningTechnologiesData,
  brandPositioningAboutData,
  brandPositioningFaqData,
} from "src/utils/mock/brandPositioningData";

export default function BrandPositioningComponent({ caseStudies: apiCaseStudies }) {
  const finalCaseStudies = apiCaseStudies || caseStudies;
  const liveProjects = finalCaseStudies?.projects?.liveProjects || [];

  const positioningProjects = liveProjects.filter((project) => {
    const hasPositioningTech = project.technologies?.some((tech) => ["branding", "marketing", "seo", "design", "positioning", "promotion"].includes(tech.name?.toLowerCase()));
    const isActive = project.projectStatus?.toLowerCase() === "active";
    return hasPositioningTech && isActive;
  });

  const filteredData = {
    ...brandPositioningPortfolioData,
    projects: {
      liveProjects: positioningProjects.length > 0 ? positioningProjects : liveProjects,
    },
  };
  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;

  return (
    <div>
      <AppHero heroData={BrandPositioningHeroData} />

      <TechStats stats={brandPositioningStatsData} />

      <WhyChooseUs data={brandPositioningSolutionsAndProcessData} />

      <section className="w-full bg-background-primary text-white px-6! md:px-12! relative overflow-hidden font-sans">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-950/20 blur-[150px] -z-10 rounded-full" />

        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />
          <ProcessStepsSection data={brandPositioningTechnologiesData} techIcons={techIcons} />
          <TechsSection mainTitle="About Brand Positioning & Promotion" sections={brandPositioningAboutData} />
        </div>
      </section>

      <FAQSection faqs={brandPositioningFaqData} />

      <CommonContactSection />
    </div>
  );
}
